const views = [
    {
        awardSlug: 'stanley-cup',
        label: 'Winners (Since 1917-18)',
        value: 'winners',
        showStanleyCupWinners: true,
        description:
            'Review a list of every Stanley Cup champion in NHL history, with links to comprehensive recaps of each winning team.',
        title: 'Stanley Cup Winners',
    },
    {
        label: 'Clinching Goals',
        value: 'clinching-goals',
        templateKey: 'GAME_WINNING_GOALS_STANLEY_CUP',
        showGameWinningGoals: true,
    },
    {
        label: 'History of the Trophy',
        templateKey: 'HISTORY_OF_THE_TROPHY',
        value: 'history-of-the-trophy',
        showContentModules: true,
    },
    {
        label: 'Traditions',
        templateKey: 'NHL_TRADITIONS',
        value: 'nhl-traditions',
        showContentModules: true,
    },
    {
        label: 'Did You Know?',
        templateKey: 'DID_YOU_KNOW',
        value: 'did-you-know',
        showContentModules: true,
        description:
            'Learn more about the Stanley Cup with fascinating facts and trivia about the most-revered trophy in sports.',
        title: 'Things to Know About the Stanley Cup',
    },
];

export default views;
